import { IClientUserData, IClientUserResponse } from '../clients';
import { IBaseContact } from './IBaseContact';
import { IPresentationContactData } from './IPresentationContactData';

// when Client contacts requested from the order level are, the response has 'emailAddress' -- NOT 'email'.
export interface IClientContactResponse extends IBaseContact<string> {
  clientUser?: IClientUserResponse;
  companyName: string;
  phoneNumber: string;
  emailAddress: string;
}

export interface IClientContactData extends Omit<IClientContactResponse, 'emailAddress'> {
  clientUser?: IClientUserData;
  email: string;
}

export const convertFromClientContactResponseToClientContactData = (
  response: IClientContactResponse
): IClientContactData => {
  const clientContactData = {};
  for (const [key, value] of Object.entries(response)) {
    if (key === 'emailAddress') {
      clientContactData['email'] = value;
    } else {
      clientContactData[key] = value;
    }
  }
  return clientContactData as IClientContactData;
};

export const convertFromClientContactDataToClientContactResponse = (
  response: IClientContactData
): IClientContactResponse => {
  const clientContactResponse = {};
  for (const [key, value] of Object.entries(response)) {
    if (key === 'email') {
      clientContactResponse['emailAddress'] = value;
    } else {
      clientContactResponse[key] = value;
    }
  }
  return clientContactResponse as IClientContactResponse;
};

export const convertFromClientContactResponseArrayToClientContactDataArray = (
  responseArray: IClientContactResponse[]
): IClientContactData[] => responseArray.map(convertFromClientContactResponseToClientContactData);

export type IPresentationClientContactData = IPresentationContactData<IClientContactData, string>;
